<div class="">
    <div class="side-menu-content">
        <div class="content">
            <div *ngIf="shouldShowViewingBanner" class="viewing-banner">
                You are viewing details of {{ viewedUserName || viewingDifferentUser }}
            </div>
            <ng-container *ngIf="groupSorted.length">
                <ng-container *ngFor="let g of groupSorted; trackBy: trackGroup">
                    <div class="{{g.group}}">
                        <ng-container *ngFor="let c of g.components; trackBy: trackComp">
                            <ng-container [ngSwitch]="c.type">
                                <ng-container *ngSwitchCase="'header-para'">
                                    <div *ngFor="let d of c.data">
                                        <app-para [isSinglePara]="d.isParaSingle" [heading]="d.header"
                                            [para]="d.paragraph" [paraLink]="d.paragraphLinks"
                                            [headerSize]="d.headerSize"></app-para>
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchCase="'accordion'">
                                    <app-accordion [panelHeader]="c?.data?.[0]?.header" [blocks]="c.data || []"
                                        [id]="$any(c.accId)" [selectedId]="selectedId"
                                        [attr.data-accordion-id]="$any(c.accId)"
                                        [usePortalBaseForRelativeLinks]="section?.route?.includes('eLearning') || section?.tab?.toLowerCase() === 'elearning'"
                                        [class.elearning-mode]="section?.tab === 'eLearning'"
                                        (openedEvent)="onChildOpened($any($event))"></app-accordion>
                                </ng-container>

                                <ng-container *ngSwitchCase="'table'">
                                    <ng-container *ngIf="c?.data?.length">
                                        <div *ngFor="let d of c.data">
                                            <app-table [sortableFields]="d.sortableFields"
                                                [displayedColumns]="d.tableHeadings" [tableData]="d.tableData"
                                                [tableUrls]="d.tableUrls" [hasLinks]="true" [tableInfo]="d.header"
                                                [dataLoadComplete]="!noData" [tableType]="d.tableType"
                                                [listItems]="d.items" [listTag]="d.listType"
                                                [filterColumn]="d.filterColumn ? d.filterColumn : (d.tableHeadings && d.tableHeadings.includes('Status') ? 'Status' : '')"
                                                [filterOptions]="d.filterOptions" [load]="loadingData">
                                            </app-table>
                                        </div>
                                    </ng-container>
                                </ng-container>

                                <ng-container *ngSwitchCase="'card-para'">
                                    <div class="{{g.group}}" *ngFor="let d of c.data">
                                        <ng-container *ngIf="c?.data?.length">
                                            <app-card-para [items]="d.contacts"></app-card-para>
                                        </ng-container>
                                    </div>
                                </ng-container>

                                <ng-container *ngSwitchCase="'form'">
                                    <app-form [data]="c.data"></app-form>
                                </ng-container>

                                <ng-container *ngSwitchCase="'button'">
                                    <div *ngFor="let d of c.data" class="json-button-row">
                                        <div class="json-button-group">
                                            <button *ngFor="let btn of ($any(d).buttons || [])" type="button"
                                                [ngClass]="btn.class || 'appoint-button'"
                                                (click)="handleJsonButton(btn)">
                                                <span class="btn-text">{{btn.text}}</span>
                                                <span class="btn-arrow" aria-hidden="true">
                                                    <mat-icon>{{btn.icon}}</mat-icon>
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-container *ngSwitchCase="'chatbot'">
                                    <div *ngFor="let d of c.data">
                                        <app-chatbot [data]="d"
                                            [userName]="userProfileData?.displayName || userProfileData?.name || null"></app-chatbot>
                                    </div>
                                </ng-container>

                                <ng-container *ngSwitchCase="'profile'">
                                    <app-profile [data]="c.data"></app-profile>
                                </ng-container>

                                <ng-container *ngSwitchCase="'search'">
                                    <app-search-tax-agents></app-search-tax-agents>
                                </ng-container>

                                <ng-container *ngSwitchCase="'tab'">
                                    <app-manage-tax-agents [data]="c.data"></app-manage-tax-agents>
                                </ng-container>

                                <ng-container *ngSwitchCase="'otb-community'">
                                    <app-otb-community [data]="c.data"></app-otb-community>
                                </ng-container>
                                <ng-container *ngSwitchCase="'appoint-call'">
                                    <app-appoint-call></app-appoint-call>
                                </ng-container>
                                <ng-container *ngSwitchCase="'otb-question-detail'">
                                    <app-otb-question-detail [data]="c.data"
                                        [questionId]="$any($any(c.data)?.question)?.id || $any(c.data)?.id || null"
                                        [userName]="userProfileData?.displayName || userProfileData?.name || null"
                                        [userId]="userProfileData?.id || userProfileData?.userId || userProfileData?.uid || null">
                                    </app-otb-question-detail>
                                </ng-container>

                                <ng-container *ngSwitchCase="'list'">

                                    <div *ngFor="let d of c.data" [attr.id]="$any(d).fragmentId || null">
                                        <ng-container [ngSwitch]="d.headerSize" *ngIf="d.headerSize; else headerBlock">
                                            <h1 *ngSwitchCase="'h1'">{{d.header}}</h1>
                                            <h2 *ngSwitchCase="'h2'">{{d.header}}</h2>
                                            <h3 *ngSwitchCase="'h3'">{{d.header}}</h3>
                                            <h4 *ngSwitchCase="'h4'">{{d.header}}</h4>
                                            <h5 *ngSwitchCase="'h5'">{{d.header}}</h5>
                                            <h6 *ngSwitchCase="'h6'">{{d.header}}</h6>
                                        </ng-container>
                                        <ng-template #headerBlock>
                                            <h5>{{d.header}}</h5>
                                        </ng-template>
                                        <ul *ngIf="!d.listType || d.listType === 'ul'">
                                            <li *ngFor="let item of d.items; let i = index"
                                                [innerHTML]="processTextWithLinks(item, d.itemLinks ? d.itemLinks[i] : '')">
                                            </li>
                                        </ul>
                                        <ol *ngIf="d.listType === 'ol'">
                                            <li *ngFor="let item of d.items; let i = index"
                                                [innerHTML]="processTextWithLinks(item, d.itemLinks ? d.itemLinks[i] : '')">
                                            </li>
                                        </ol>
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchCase="'nested-list-para-link'">
                                    <div *ngFor="let d of c.data" [attr.id]="$any(d).fragmentId || null">
                                        <app-nested-list-para-link [items]="d.listItem" [heading]="d.header"
                                            [listType]="d.listType"></app-nested-list-para-link>
                                    </div>
                                </ng-container>

                                <ng-container *ngSwitchCase="'nested-list'">
                                    <div *ngFor="let d of c.data; let i = index" [attr.id]="$any(d).fragmentId || null">
                                        <ol style="list-style-type: none; padding-left: 0;">
                                            <li *ngFor="let item of d.items; let j = index"
                                                style="margin-bottom: 0.5em;">
                                                <span
                                                    *ngIf="isObject(item); else simpleItem">{{getPrefix(j,c.data[i].listType)}}
                                                    {{getItemText(item)}}</span>
                                                <ng-template #simpleItem>{{getPrefix(j,'')}} {{item}}</ng-template>
                                                <ol *ngIf="isObject(item) && getItemNestedList(item)"
                                                    style="list-style-type: none; margin-top: 0.5em; margin-left: 1em;">
                                                    <li *ngFor="let nestedItem of getItemNestedList(item).items; let k = index"
                                                        style="margin-bottom: 0.25em;">
                                                        {{getPrefix(k, item)}} {{nestedItem}}
                                                    </li>
                                                </ol>
                                            </li>
                                        </ol>
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchCase="'contact-information'">
                                    <app-contact-information></app-contact-information>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </div>
                </ng-container>
            </ng-container>
            <div *ngIf="groupSorted.length == 0">
                <app-data-unavailable></app-data-unavailable>
            </div>
        </div>
        <div style="margin-top: 2em;">
            <!-- <app-rating [rating]="0"></app-rating> -->
        </div>
    </div>
</div>